// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2xgo4","row":"styles_row__3v8a_"};